// extracted by mini-css-extract-plugin
module.exports = {"franchise_shows_tab":"FranchiseShowsTab_franchise_shows_tab__SddQ_"};